(() => {
  const mountProductSliders = () => {
    document.querySelectorAll('media-gallery.media-gallery--grid').forEach((gallery) => {
      if (gallery.dataset.aksSliderMounted === 'true') return;

      const slideshow = gallery.querySelector('slideshow-component');
      const slides = slideshow?.querySelectorAll('slideshow-slide');
      if (!slideshow || !slides || slides.length < 2) return;

      const nav = document.createElement('div');
      nav.className = 'aks-product-slider-nav';
      nav.innerHTML = `
        <button class="aks-product-slider-nav__button aks-product-slider-nav__button--prev" type="button" aria-label="Vorheriges Produktbild"><span aria-hidden="true">‹</span></button>
        <button class="aks-product-slider-nav__button aks-product-slider-nav__button--next" type="button" aria-label="Nächstes Produktbild"><span aria-hidden="true">›</span></button>
      `;

      nav.querySelector('.aks-product-slider-nav__button--prev')?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (typeof slideshow.previous === 'function') slideshow.previous();
      });

      nav.querySelector('.aks-product-slider-nav__button--next')?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (typeof slideshow.next === 'function') slideshow.next();
      });

      gallery.appendChild(nav);
      gallery.dataset.aksSliderMounted = 'true';
    });
  };

  const start = () => {
    if (window.customElements?.whenDefined) {
      customElements.whenDefined('slideshow-component').then(mountProductSliders).catch(mountProductSliders);
    } else {
      mountProductSliders();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', mountProductSliders);
})();
